import { render, staticRenderFns } from "./ContactListEditor.vue?vue&type=template&id=f16b34f4&"
import script from "./ContactListEditor.vue?vue&type=script&lang=js&"
export * from "./ContactListEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VDivider,VInput})
